import React from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "../../../assets/aboutUs/about6.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "60% 40%",
    overflow: "hidden",
  },
  text: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  paragraph: {
    width: "55%",
    color: "#272727",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "18px",
    textAlign: "end",
    margin: `0 ${spacing(3)}px`,
  },
  year: {
    color: "#272727",
    fontWeight: "bold",
    fontSize: "122px",
    lineHeight: "100%",
    margin: `0 ${spacing(3)}px`,
  },
  img: {
    height: "100%",
  },
}));

const about6 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Box component="div" className={classes.text}>
        <Typography className={classes.paragraph} p="true">
          Cambia la razón social de la Sociedad y nace ILUMINARTE S.A. que es
          como se conoce actualmente y bajo esa marca se comercializan nuevas
          líneas y tendencias del mercado de velas, manteniendo siempre las
          velas de tipo religioso pero agregando las de tipo decorativo o de
          ocasión, que son tan buscadas en la actualidad para acompañar momentos
          especiales. A partir de ese momento, se ha tenido la oportunidad de
          vender localmente, y también a países como El Salvador, Honduras,
          Nicaragua y el sur de México.
        </Typography>
        <Typography className={classes.year} variant="h3">
          2016
        </Typography>
        <Typography className={classes.paragraph} p="true">
          Al año 2020 los canales de distribución fueron directos, por lo que a
          partir de este año se ha empezado a incursionar en las tiendas de
          consumo masivo como proyecto para 2021-2025. De igual forma se inician
          los procesos para dar a conocer la empresa de manera digital, con el
          objetivo de mostrarse como una industria familiar nacional, en vías de
          expansión y con oportunidades ilimitadas de creación.
        </Typography>
        <Typography className={classes.year} variant="h3">
          2021
        </Typography>
      </Box>
      <Box component="div" className={classes.image}>
        <CardMedia className={classes.img} component="img" image={photo} />
      </Box>
    </Box>
  );
};

export default about6;
